import styled from "@emotion/styled";

export const COLORS = {
  /* Brand Accent */
  accent: "#5E84ED", // -- accent primary
  btnHover: "#2457E3", // -- accent pressed
  link: "#8FB0FF", // -- accent hover/links
  accentGlow: "rgba(94,132,237,0.15)",

  /* Neutrals (dark scale) */
  appBg: "#1A1A1C", // -- neutral canvas
  surface: "#1E1F22", // -- neutral surface
  card: "#26282D", // -- neutral raised
  cardElevated: "#2B2D33", // -- neutral depth
  neutralOverlay: "rgba(255,255,255,0.05)",

  /* Text */
  textPrimary: "#E9ECF5", // -- text primary
  textSecondary: "#C5CAD6", // -- text secondary
  textMuted: "#8F95A3", // -- text muted
  textPlaceholder: "#7D8493", // -- text placeholder
  onPrimary: "#FFFFFF", // -- text/inverse

  /* Feedback */
  danger: "#D65F46", // -- danger
  dangerPressed: "#9E3D2C", // -- pressed (danger pressed)
  success: "#3FCF9B", // -- success
  warning: "#E6B76A", // -- warning

  /* Utility */
  border: "#2B2D33", // -- border 300
  divider: "#2B2D33", // -- divider 300
  shadowOverlay: "rgba(0,0,0,0.40)", // -- shadow overlay
  scrim50: "rgba(0,0,0,0.50)", // -- scrim 50

  /* Legacy / app-specific (kept for compatibility) */
  sidebar: "#24262A",
  sidebarBorder: "#2B2D33",
  primaryContainer: "#273258",
  onPrimaryContainer: "#E9ECF5",
  btnRest: "#406CE7",
  btnActive: "#1A49CF",
  btnText: "#FFFFFF",
  btnDisabled: "#2A2A2E",
  outline: "#343844",
  focusRing: "#98B3FF",
};

export const OnboardingContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${COLORS.appBg};
  height: 100%;
  max-height: 100%;
  overflow: hidden;
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #b7bdcb;
  font-size: 16px;
  font-family: "Custora", serif;
  font-weight: 500;
  line-height: 140%;
  word-wrap: break-word;
  padding: 16px;
  overflow: auto;
  flex: 1;
`;

export const OnboardingWelcomeContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  background: rgba(38, 40, 45, 0.3);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  border-radius: 16px;
  font-family: "Custora", serif;
`;

export const OnboardingWelcomeHeaderSpeaker = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
  cursor: pointer;
`;

export const LogoContainer = styled.div`
  width: 77px;
  height: 77px;
  align-self: center;
  background: rgba(94, 132, 237, 0.18);
  box-shadow: 24px 24px 24px;
  border-radius: 999px;
  filter: blur(12px);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LogoBackground = styled.div`
  width: 64px;
  height: 64px;
  background: #2457e3;
  border-radius: 999px;
  border: 1px rgba(143, 176, 255, 0) solid;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OnboardingWelcomeLogo = styled.img`
  height: auto;
  position: absolute;
`;

export const OnboardingWelcomeText = styled.p`
  line-height: 150%;
  font-size: 18px;
  text-align: center;
  color: ${COLORS.textPrimary};
  width: 307px;
  align-self: center;
  font-family: "Custora", serif;
  font-weight: 400;
  margin: 0;
  word-wrap: break-word;
`;

export const OnboardingWelcomeTextWithoutExtras = styled.p`
  line-height: 150%;
  font-size: 16px;
  text-align: center;
  color: ${COLORS.textPrimary};
  width: 307px;
  align-self: center;

  /* switch from Lora to your custom family */
  font-family: "Custora", serif;
  font-weight: 300; /* your new light */
`;

export const Button = styled.button<{ primary?: boolean }>`
  font-family: "Inter", sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 44px;
  cursor: pointer;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 12px;
  line-height: 140%;
  word-wrap: break-word;
  padding-bottom: 12px;
  border-radius: 12px;
  background: ${(props) => (props.primary ? "#5e84ed" : "transparent")};
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  color: ${(props) => (props.primary ? "#fff" : "#5e84ed")};
  border: ${(props) => (props.primary ? "none" : "1px solid")};

  &:hover {
    background: ${(props) => (props.primary ? "" : "rgba(94,132,237,0.1)")};
    color: ${(props) => (props.primary ? "#fff" : "#5e84ed")};
  }
`;

export const AnswerSubmittedOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
`;

export const AnswerSubmitted = styled.span`
  color: #e9ecf5;
  font-size: 15px;
  font-family: Inter;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
  padding: 8px 24px;
  background: #282f45;
  border-radius: 20px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.10);
`;
